import { Form } from 'formik';
import { FormikDebounce } from '../common/form/FormikDebounce';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import * as Yup from 'yup';
import { validations } from '../../utils/validations';
import { FormContainer } from '../common/form/FormContainer';
import { SubmitButton } from '../common/form/SubmitButton';
import { SectionHeader } from '../common/SectionHeader';
import { Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../common/basic/QcsModalBox';
import { TrainingAutocomplete } from '../common/form/TrainingAutocomplete';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { workplaceService } from '@api/services/services';
import { ShowError } from '../ShowError';
import { resources } from '@api/resources';

interface AddTrainingForm {
  training?: ReferenceDto | null;
}

interface Props {
  open: boolean;
  onClose: () => void;
  reloadTrainings: () => void;
  excludeIds: string[];
}

export const AddTrainingModal: FC<Props> = ({ open, onClose, reloadTrainings, excludeIds }) => {
  const { t } = useTranslation();
  const { workplaceId } = useParams();

  const handleSubmit = async (data: AddTrainingForm) => {
    await workplaceService.addTrainingToWorkPlace(workplaceId!, data.training!);
    reloadTrainings();
    onClose();
  };

  return (
    <QcsModal open={open} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title="workplaceTraining.add" />
        <FormikDebounce<AddTrainingForm>
          initialValues={{ training: null }}
          validationSchema={Yup.object().shape({
            training: validations.objectRequired(t),
          })}
          onSubmit={handleSubmit}
        >
          <Form>
            <FormContainer>
              <TrainingAutocomplete
                name="training"
                label={t('workplaceTraining.training')}
                required
                excludeIds={excludeIds}
                ignoreWithoutQuestionnaireWithLanguage
              />

              <ShowError resource={resources.addTrainingToWorkPlace} />
              <SubmitButton />
            </FormContainer>
          </Form>
        </FormikDebounce>
      </QcsModalBox>
    </QcsModal>
  );
};
